"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledWrapper = exports.StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledWrapper",
  componentId: "sc-up77ak-0"
})(["display:inline-flex;padding:4px 8px;align-items:flex-start;gap:10px;border-radius:4px;background-color:", ";color:", ";margin-right:5px;text-overflow:elipsis;white-space:nowrap;align-self:center;overflow:hidden;@media (max-width:800px){font-size:10px;}"], function (_ref) {
  var label = _ref.label;
  return label ? _palette.commonPalette.bannerInformational : _palette.commonPalette.bannerDefault;
}, function (_ref2) {
  var label = _ref2.label;
  return label ? _palette.commonPalette.iconInformational : _palette.commonPalette.iconDefault;
});
//# sourceMappingURL=styles.js.map